import {
  Component,
  OnInit,
  Input,
  SimpleChanges,
  EventEmitter,
  Output,
} from "@angular/core";
import { LineItemMonitorDataService } from "../line-item-monitor-data.service";
import {
  GridHeader,
  GridValue,
  LineItemMonitorMeta,
  RevisionValues,
} from "../line-item-monitor.model";
import { getUpdatedPeriodData } from "../util";
import {
  VAIconRegistryService,
  exclamationTriangle,
} from "@va/core-library/icons";

@Component({
  selector: "app-revision-lim",
  templateUrl: "./revision-lim.component.html",
  styleUrls: ["./revision-lim.component.scss"],
})
export class RevisionLimComponent implements OnInit {
  @Input() ticker: string;
  @Input() lineItemsMeta: LineItemMonitorMeta;
  @Input() revisionStart: string;
  @Output() updatePeriod: EventEmitter<any> = new EventEmitter();

  isLoading: boolean;
  gridHeader: GridHeader = {
    level1: [
      {
        label: "",
        subscript: "",
        rowspan: "2",
        colspan: "2",
      },
    ],
    level2: [],
  };
  gridValues: Array<GridValue> = [];
  widthConfig = ["237px", "30px"];

  constructor(
    private dataService: LineItemMonitorDataService,
    private iconRegistry: VAIconRegistryService,
  ) {
    this.iconRegistry.registerIcons([exclamationTriangle]);
  }

  ngOnInit() {
    this.isLoading = true;
    this.gridHeader.level1[0].subscript = `All numbers in ${this.lineItemsMeta.currency_value} unless stated otherwise`;
    this.lineItemsMeta.period_list.forEach((period) => {
      const header = {
        label: `${period}`,
        colspan: "3",
      };
      this.gridHeader.level1.push(header);
      this.widthConfig.push("86px", "86px", "98px");
    });
  }
  ngOnChanges(changes: SimpleChanges) {
    if (
      (changes.revisionStart &&
        changes.revisionStart.currentValue !==
          changes.revisionStart.previousValue) ||
      (changes.ticker &&
        changes.ticker.previousValue !== changes.ticker.currentValue) ||
      (changes.lineItemsMeta &&
        changes.lineItemsMeta.previousValue !==
          changes.lineItemsMeta.currentValue)
    ) {
      const payload = {
        ticker: this.ticker,
        revision: this.revisionStart,
        param_ids: this.lineItemsMeta.line_items.map(
          (line) => line.dapparameterid,
        ),
      };
      this.gridValues = [];
      this.isLoading = true;
      this.lineItemsMeta.period_list.forEach((period) => {
        this.getPeriodData({ ...payload, period: [period] });
      });
      if (
        (changes.ticker &&
          changes.ticker.previousValue !== changes.ticker.currentValue) ||
        (changes.revisionStart &&
          changes.revisionStart.currentValue !==
            changes.revisionStart.previousValue)
      ) {
        this.makeLevel2Header();
      }
    }
  }
  makeLevel2Header() {
    this.gridHeader.level2 = [];
    this.lineItemsMeta.period_list.forEach(() => {
      // this.widthConfig.push("104px", "104px", "104px");
      this.gridHeader.level2.push([
        {
          label: RevisionValues[this.revisionStart],
        },
        {
          label: "Current",
        },
        {
          label: "%Change",
        },
      ]);
    });
  }
  getPeriodData(payload) {
    this.dataService.getLIMData(payload).subscribe((response) => {
      this.mapApiToGridData(response);
    });
  }
  mapApiToGridData(response) {
    response.data.forEach((periodData) => {
      //find all indexes for this period, we allow duplicate periods in grid
      const periodIndexes = this.lineItemsMeta.period_list
        .map((period, index) => {
          return period === periodData.period ? index : "";
        })
        .filter((idx) => idx !== "");
      periodData.data.forEach((row) => {
        const rowIndex = this.lineItemsMeta.rowHeaders[row.dap_id].rowIndex;
        const values = [
          {
            ...this.dataService.getFormat(
              row.revision_value,
              true,
              row.unit,
              true,
            ),
            tooltip: null,
          },
          {
            ...this.dataService.getFormat(row.current, true, row.unit, true),
            tooltip: null,
          },
          {
            ...this.dataService.getFormat(
              row.perc_change,
              false,
              row.unit,
              false,
            ),
            tooltip: null,
          },
        ];
        if (!this.gridValues[rowIndex]) {
          this.gridValues[rowIndex] = new GridValue();
        }
        if (!this.gridValues[rowIndex].values) {
          this.gridValues[rowIndex].values = Array(4);
        }
        const rowValues = {
          id: row.dap_id,
          header: this.lineItemsMeta.rowHeaders[row.dap_id].header,
          values: [...this.gridValues[rowIndex].values],
        };
        periodIndexes.forEach((idx) => (rowValues.values[idx] = values));
        this.gridValues[rowIndex] = rowValues;
      });
    });
    this.gridValues = [...this.gridValues];
    this.isLoading = false;
    // console.log(this.gridValues);
  }

  onPeriodChange(periodIndex, value, selectedPeriod) {
    getUpdatedPeriodData.call(
      this,
      { revision: this.revisionStart },
      periodIndex,
      value,
      selectedPeriod,
    );
  }
}
